import { Component, OnInit } from '@angular/core';
import {Router} from "@angular/router";
import {AuthService} from "../../auth/auth.service";
import {StorageService} from "../../auth/storage.service";

@Component({
  selector: 'app-header-inner',
  templateUrl: './header-inner.component.html',
  styleUrls: ['./header-inner.component.css']
})
export class HeaderInnerComponent  implements OnInit {
 
    
    public email : string;
    public fullname : string;
    
    constructor(
              private authService: AuthService,
              private storageService: StorageService,
              private router: Router) { }
    
    ngOnInit() {
        this.email = this.storageService.getCurrentUser().email;
        this.fullname = this.storageService.getCurrentUser().firstName + ' ' + this.storageService.getCurrentUser().lastName;
    }
    
    public logout(): void {
        this.authService.logout();
        this.storageService.removeCurrentSession();
        this.router.navigate(['/login']);    
    }    
}
